export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtRozmerPneuDisku';
export const NAME = 'RozmerPneuDisk';
